import { useEffect } from 'react'

import { useDispensaryContext } from '../../dispensaries'
import { useOnboardPatientClaim } from '../../onboarding/hooks/useOnboardPatientClaim'
import { usePageUrl } from '../../pages'

const usePatientOnboardingCompleteGuard = (): void => {
  const { isOnboardingComplete } = useOnboardPatientClaim()
  const { navigate } = usePageUrl()
  const currentDispensary = useDispensaryContext()

  useEffect(() => {
    // To allow a patient to complete onboarding via checkout,
    // don't display the onboarding notifications if the patient is currently on a dispensary
    if (!isOnboardingComplete && !currentDispensary) {
      navigate('/checkout/onboarding')
    }
  }, [isOnboardingComplete, currentDispensary, navigate])
}

export default usePatientOnboardingCompleteGuard
